<template>
  <div class="app-container coupon-page">
    <div class="filter-card">
      <div class="page-title">优惠券管理</div>
      <div class="filters">
        <el-input
          v-model.trim="query.title"
          clearable
          placeholder="请输入优惠券名称"
          @keyup.enter.native="search"
        />
        <el-select v-model="query.displayStatus" clearable placeholder="全部状态">
          <el-option v-for="s in statuses" :key="s.value" :label="s.label" :value="s.value" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>

    <div class="table-card">
      <div class="toolbar">
        <el-button type="primary" icon="el-icon-plus" @click="openForm()">新增优惠券</el-button>
      </div>
      <el-table v-loading="loading" :data="list" border>
        <el-table-column prop="title" label="优惠券名称" min-width="150" fixed="left" />
        <el-table-column label="营销券种" width="95"
          ><template slot-scope="s">{{ campaignText(s.row.campaignType) }}</template></el-table-column
        >
        <el-table-column label="领取方式" width="95"
          ><template slot-scope="s">{{
            receiveModeText(effectiveReceiveMode(s.row))
          }}</template></el-table-column
        >
        <el-table-column label="类型" width="90"><template>满减券</template></el-table-column>
        <el-table-column label="面值" width="95"
          ><template slot-scope="s">¥{{ money(s.row.discountAmount) }}</template></el-table-column
        >
        <el-table-column label="主动领取" width="95"
          ><template slot-scope="s">{{
            s.row.manualReceive === 0 ? "否" : "是"
          }}</template></el-table-column
        >
        <el-table-column label="数量" min-width="165">
          <template slot-scope="s"
            ><div class="count-lines">
              <span>剩余 / 总数：{{ remainingQuantityText(s.row) }}</span>
              <span>已领取：{{ s.row.receivedQuantity || 0 }} 张</span
              ><span>已发放：{{ s.row.issuedQuantity || 0 }} 张</span
              ><span>已使用：{{ s.row.usedQuantity || 0 }} 张</span>
            </div></template
          >
        </el-table-column>
        <el-table-column label="适用范围" min-width="180"
          ><template slot-scope="s"
            ><span class="scope-text" :title="scopeText(s.row)">{{
              scopeText(s.row)
            }}</span></template
          ></el-table-column
        >
        <el-table-column label="使用门槛" min-width="120"
          ><template slot-scope="s">{{
            Number(s.row.thresholdAmount) > 0
              ? "满" + money(s.row.thresholdAmount) + "元可用"
              : "无门槛"
          }}</template></el-table-column
        >
        <el-table-column label="有效期" min-width="165"
          ><template slot-scope="s">{{ validityText(s.row) }}</template></el-table-column
        >
        <el-table-column label="领取有效期" min-width="190"
          ><template slot-scope="s">{{ claimText(s.row) }}</template></el-table-column
        >
        <el-table-column label="状态" width="90"
          ><template slot-scope="s"
            ><el-tag :type="statusType(s.row.displayStatus)">{{
              statusText(s.row.displayStatus)
            }}</el-tag></template
          ></el-table-column
        >
        <el-table-column label="操作" min-width="250" fixed="right">
          <template slot-scope="s">
            <el-button
              v-if="s.row.displayStatus === 1 || s.row.displayStatus === 2"
              type="text"
              @click="openForm(s.row)"
              >编辑</el-button
            >
            <el-button v-if="s.row.displayStatus === 2" type="text" @click="closeCoupon(s.row)"
              >关闭</el-button
            >
            <el-button
              v-if="s.row.displayStatus === 1"
              type="text"
              class="danger-link"
              @click="remove(s.row)"
              >删除</el-button
            >
            <el-button type="text" @click="openRecords(s.row)">领取记录</el-button>
            <el-button
              v-if="s.row.displayStatus === 2 && effectiveReceiveMode(s.row) === 2"
              type="text"
              @click="openIssue(s.row)"
              >发放</el-button
            >
            <el-button type="text" @click="openIssueRecords(s.row)">发放记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="query.page"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @current-change="changePage"
        @size-change="changeSize"
      />
    </div>

    <el-dialog
      :title="form.id ? '编辑优惠券' : '新增优惠券'"
      :visible.sync="formVisible"
      width="760px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="优惠券名称" prop="title"
          ><el-input v-model.trim="form.title" maxlength="50" show-word-limit
        /></el-form-item>
        <el-form-item label="优惠金额" prop="discountAmount"
          ><el-input-number
            v-model="form.discountAmount"
            :min="0.01"
            :precision="2"
            :step="1"
          /><span class="unit">元</span></el-form-item
        >
        <el-form-item label="营销券种">
          <el-radio-group v-model="form.campaignType" @change="handleCampaignTypeChange">
            <el-radio :label="1">普通券</el-radio>
            <el-radio :label="2">邀请券</el-radio>
            <el-radio :label="3">新人券</el-radio>
          </el-radio-group>
          <div v-if="form.campaignType === 2" class="campaign-tip">
            仅统计活动期间新绑定到该用户名下的直属新用户，达到邀请档位后自动发券。
          </div>
          <div v-if="form.campaignType === 3" class="campaign-tip">
            仅面向尚未完成首笔订单的新注册用户；首笔订单交易完成后不再具备领取或自动发放资格。
          </div>
        </el-form-item>
        <el-form-item label="适用范围" prop="scopeType">
          <el-radio-group v-model="form.scopeType" @change="handleScopeTypeChange"
            ><el-radio :label="1">全场通用</el-radio><el-radio :label="3">品类券</el-radio
            ><el-radio :label="2">商品券</el-radio
            ><el-radio :label="4">商品专区</el-radio></el-radio-group
          >
          <div v-if="form.scopeType === 2" class="scope-picker">
            <el-button icon="el-icon-goods" @click="productVisible = true">选择商品</el-button
            ><span>已选 {{ selectedProducts.length }} 个</span>
          </div>
          <category-scope-picker
            v-if="form.scopeType === 3"
            v-model="selectedCategoryIds"
            class="scope-category-picker"
          />
          <el-select
            v-if="form.scopeType === 4"
            v-model="form.scopeValue"
            multiple
            collapse-tags
            placeholder="请选择商品专区"
            style="width:100%"
          >
            <el-option
              v-for="p in productTypes"
              :key="p.key"
              :label="p.value"
              :value="String(p.key)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="使用门槛"
          ><el-radio-group v-model="form.thresholdType"
            ><el-radio :label="1">满减券</el-radio
            ><el-radio :label="0">无门槛券</el-radio></el-radio-group
          >
          <div v-if="form.thresholdType === 1" class="inline-field">
            最低满
            <el-input-number v-model="form.thresholdAmount" :min="0.01" :precision="2" /> 元可用
          </div></el-form-item
        >
        <el-form-item label="有效期"
          ><el-radio-group v-model="form.validityType"
            ><el-radio :label="1">领取后按天数</el-radio
            ><el-radio :label="2">固定截止时间</el-radio></el-radio-group
          >
          <div class="inline-field" v-if="form.validityType === 1">
            领券后立即生效，有效期
            <el-input-number v-model="form.validDays" :min="1" :max="3650" /> 天
          </div>
          <el-date-picker
            v-else
            v-model="form.useEndTime"
            type="datetime"
            value-format="timestamp"
            placeholder="请选择使用截止时间"
        /></el-form-item>
        <el-form-item label="领取方式">
          <el-radio-group v-model="form.receiveMode" @change="syncManualReceive">
            <el-radio :label="1" :disabled="form.campaignType === 2">手动领取</el-radio>
            <el-radio :label="2" :disabled="form.campaignType === 2">后台发放</el-radio>
            <el-radio :label="3" :disabled="form.campaignType === 1 || form.campaignType === 2"
              >自动发放</el-radio
            >
          </el-radio-group>
          <div class="help">
            手动领取由用户操作；后台发放由运营选择用户；自动发放由系统按营销条件触发。邀请券固定为自动发放。
          </div>
        </el-form-item>
        <el-form-item v-if="form.campaignType === 2" label="邀请奖励">
          <div class="invite-rule">
            活动期间每邀请
            <el-input-number v-model="form.inviteRequiredCount" :min="1" :max="999999" />
            名直属新用户，奖励
            <el-input-number v-model="form.inviteRewardQuantity" :min="1" :max="999" /> 张
          </div>
        </el-form-item>
        <el-form-item label="活动时间">
          <el-radio-group v-model="form.claimTimeType">
            <el-radio :label="1">限时</el-radio>
            <el-radio v-if="form.campaignType !== 2" :label="0">不限时</el-radio>
          </el-radio-group>
          <el-date-picker
            v-if="form.claimTimeType === 1"
            v-model="form.claimRange"
            type="datetimerange"
            value-format="timestamp"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          />
        </el-form-item>
        <template v-if="form.receiveMode === 1">
          <el-form-item label="可领取总量">
            <el-radio-group v-model="form.quantityType">
              <el-radio :label="1">限量</el-radio>
              <el-radio :label="0">不限量</el-radio>
            </el-radio-group>
            <div v-if="form.quantityType === 1" class="inline-field">
              <el-input-number v-model="form.totalQuantity" :min="1" :max="99999999" /> 张
            </div>
          </el-form-item>
          <el-form-item label="每人限领">
            <el-input-number v-model="form.userLimit" :min="0" :max="999" />
            <span class="unit">张，0 表示不限</span>
          </el-form-item>
        </template>
        <el-form-item v-if="form.campaignType === 2" label="最多参与">
          <el-input-number v-model="form.userLimit" :min="1" :max="999" />
          <span class="unit"
            >次；最多奖励
            {{ (Number(form.userLimit) || 0) * (Number(form.inviteRewardQuantity) || 0) }} 张</span
          >
        </el-form-item>
      </el-form>
      <span slot="footer"
        ><el-button @click="formVisible = false">取消</el-button
        ><el-button type="primary" :loading="saving" @click="submit">保存</el-button></span
      >
    </el-dialog>

    <el-dialog
      title="优惠券发放"
      :visible.sync="issueVisible"
      width="680px"
      :close-on-click-modal="false"
    >
      <el-form label-width="110px">
        <el-form-item label="优惠券名称"
          ><strong>{{ activeCoupon && activeCoupon.title }}</strong></el-form-item
        >
        <el-form-item label="每人发放数量"
          ><el-input-number v-model="issue.quantity" :min="1" :max="999" /><span class="unit"
            >张</span
          >
          <div class="help">后台发放不受主动领取剩余数量限制</div></el-form-item
        >
        <el-form-item label="发放会员"
          ><el-radio-group v-model="issue.targetType"
            ><el-radio :label="1">全部会员</el-radio><el-radio :label="2">选择会员</el-radio
            ><el-radio :label="3">按会员等级</el-radio></el-radio-group
          ></el-form-item
        >
        <el-form-item v-if="issue.targetType === 2"
          ><el-button @click="memberVisible = true">选择会员</el-button
          ><span class="unit">已选 {{ selectedMembers.length }} 人</span></el-form-item
        >
        <el-form-item v-if="issue.targetType === 3" label="会员等级"
          ><el-select
            v-model="issue.gradeIds"
            multiple
            placeholder="请选择会员等级"
            style="width:100%"
            ><el-option v-for="g in grades" :key="g.id" :label="g.name" :value="g.id"/></el-select
        ></el-form-item>
      </el-form>
      <span slot="footer"
        ><el-button @click="issueVisible = false">取消</el-button
        ><el-button type="primary" :loading="issuing" @click="doIssue">确认发放</el-button></span
      >
    </el-dialog>

    <el-dialog title="优惠券领取记录" :visible.sync="recordsVisible" width="84%">
      <div class="record-summary">
        <div>
          <b>{{ recordStats.total }}</b
          ><span>已领取</span>
        </div>
        <div>
          <b>{{ recordStats.used }}</b
          ><span>已使用</span>
        </div>
        <div>
          <b>{{ recordStats.expired }}</b
          ><span>已过期</span>
        </div>
        <div>
          <b>{{ recordStats.invalid }}</b
          ><span>已失效</span>
        </div>
      </div>
      <div class="filters compact">
        <el-input
          v-model.trim="recordQuery.keyword"
          clearable
          placeholder="账号/姓名/手机号"
        /><el-select v-model="recordQuery.status" clearable placeholder="全部状态"
          ><el-option label="待使用" :value="1"/><el-option label="已使用" :value="2"/><el-option
            label="已过期"
            :value="3"/><el-option label="已失效" :value="4"/></el-select
        ><el-button type="primary" @click="loadRecords">搜索</el-button>
      </div>
      <el-table v-loading="recordLoading" :data="records" border
        ><el-table-column prop="title" label="优惠券名称" /><el-table-column label="会员"
          ><template slot-scope="s"
            >ID：{{ s.row.userId }}<br />{{ s.row.userName || "-" }}
            {{ s.row.userMobile || "" }}</template
          ></el-table-column
        ><el-table-column label="领取方式"
          ><template slot-scope="s">{{ sourceText(s.row.issueSource) }}</template></el-table-column
        ><el-table-column label="领取时间"
          ><template slot-scope="s">{{ date(s.row.ctdate) }}</template></el-table-column
        ><el-table-column label="到期时间"
          ><template slot-scope="s">{{ date(s.row.endTime) }}</template></el-table-column
        ><el-table-column label="当前状态"
          ><template slot-scope="s">{{ couponStatus(s.row.status) }}</template></el-table-column
        ><el-table-column label="使用时间"
          ><template slot-scope="s">{{ date(s.row.useTime) }}</template></el-table-column
        ></el-table
      >
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :total="recordTotal"
        :current-page="recordQuery.page"
        :page-size="recordQuery.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @current-change="recordPage"
        @size-change="recordSize"
      />
    </el-dialog>

    <el-dialog title="优惠券发放记录" :visible.sync="issueRecordsVisible" width="72%">
      <el-table v-loading="issueRecordLoading" :data="issueRecords" border
        ><el-table-column prop="title" label="优惠券名称" /><el-table-column label="发放对象"
          ><template slot-scope="s">{{ s.row.userCount }} 位会员</template></el-table-column
        ><el-table-column prop="issueCount" label="发放数量" /><el-table-column label="来源"
          ><template slot-scope="s">{{ sourceText(s.row.issueSource) }}</template></el-table-column
        ><el-table-column prop="issuerId" label="操作人ID" /><el-table-column label="发放时间"
          ><template slot-scope="s">{{ date(s.row.issueTime) }}</template></el-table-column
        ></el-table
      >
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :total="issueRecordTotal"
        :current-page="issueRecordQuery.page"
        :page-size="issueRecordQuery.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @current-change="issueRecordPage"
        @size-change="issueRecordSize"
      />
    </el-dialog>

    <product-select-dialog
      v-model="productVisible"
      :selected-rows="selectedProducts"
      @confirm="selectProducts"
    />
    <member-select-dialog
      v-model="memberVisible"
      :selected-rows="selectedMembers"
      @confirm="selectedMembers = $event"
    />
  </div>
</template>

<script>
import moment from "moment";
import {
  getCouponList,
  saveCoupon,
  updateCouponStatus,
  deleteCoupon,
  issueCoupon,
  getCouponRecords,
  getCouponIssueRecords
} from "@/api/coupon";
import { getGradeList } from "@/api/system";
import { PRODUCT_TYPE } from "@/utils/enumUtile";
import ProductSelectDialog from "./ProductSelectDialog.vue";
import MemberSelectDialog from "./MemberSelectDialog.vue";
import CategoryScopePicker from "./CategoryScopePicker.vue";
import { getCategoryTree } from "@/api/category";
const FAR_FUTURE = 4102444799000;
export default {
  name: "CouponManagement",
  components: { ProductSelectDialog, MemberSelectDialog, CategoryScopePicker },
  data() {
    return {
      loading: false,
      saving: false,
      issuing: false,
      list: [],
      total: 0,
      query: { title: "", displayStatus: null, page: 1, pageSize: 10 },
      statuses: [
        { value: 1, label: "未开始" },
        { value: 2, label: "进行中" },
        { value: 3, label: "已过期" },
        { value: 4, label: "已失效" }
      ],
      productTypes: PRODUCT_TYPE || [],
      grades: [],
      formVisible: false,
      productVisible: false,
      memberVisible: false,
      selectedProducts: [],
      selectedCategoryIds: [],
      selectedMembers: [],
      form: {},
      categoryNameMap: {},
      rules: {
        title: [{ required: true, message: "请输入优惠券名称", trigger: "blur" }],
        discountAmount: [{ required: true, message: "请输入优惠金额", trigger: "change" }]
      },
      activeCoupon: null,
      issueVisible: false,
      issue: { targetType: 1, quantity: 1, gradeIds: [] },
      recordsVisible: false,
      recordLoading: false,
      records: [],
      recordTotal: 0,
      recordQuery: { templateId: null, keyword: "", status: null, page: 1, pageSize: 10 },
      recordStats: { total: 0, used: 0, expired: 0, invalid: 0 },
      issueRecordsVisible: false,
      issueRecordLoading: false,
      issueRecords: [],
      issueRecordTotal: 0,
      issueRecordQuery: { templateId: null, page: 1, pageSize: 10 }
    };
  },
  created() {
    this.load();
    this.loadCategoryNames();
    getGradeList().then(r => {
      this.grades = r.data || [];
    });
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const r = await getCouponList(this.query);
        const d = r.data || {};
        let rows = (d.entitys || []).map(row =>
          Object.assign({}, row, { displayStatus: this.resolveDisplayStatus(row) })
        );
        rows = await this.fillMissingStatistics(rows);
        this.list = rows;
        this.total = d.totalCount || 0;
      } finally {
        this.loading = false;
      }
    },
    async fillMissingStatistics(rows) {
      const missing = rows.some(
        row =>
          row.remainingQuantity == null ||
          row.receivedQuantity == null ||
          row.issuedQuantity == null ||
          row.usedQuantity == null
      );
      if (!missing) return rows;
      try {
        const response = await getCouponRecords({ page: 1, pageSize: 100000 });
        const records = (response.data && response.data.entitys) || [];
        const statistics = {};
        records.forEach(record => {
          const key = String(record.templateId);
          if (!statistics[key]) statistics[key] = { received: 0, issued: 0, used: 0 };
          const source = Number(record.issueSource);
          if (source === 2 || source === 3) statistics[key].issued += 1;
          else statistics[key].received += 1;
          if (Number(record.status) === 2) statistics[key].used += 1;
        });
        return rows.map(row => {
          const stat = statistics[String(row.id)] || { received: 0, issued: 0, used: 0 };
          const total = Number(row.totalQuantity);
          return Object.assign({}, row, {
            receivedQuantity: stat.received,
            issuedQuantity: stat.issued,
            usedQuantity: stat.used,
            remainingQuantity:
              total < 0 ? -1 : Math.max(0, (Number.isFinite(total) ? total : 0) - stat.received)
          });
        });
      } catch (e) {
        return rows.map(row => {
          const total = Number(row.totalQuantity);
          const received = Number(row.receivedQuantity || 0);
          return Object.assign({}, row, {
            receivedQuantity: received,
            issuedQuantity: Number(row.issuedQuantity || 0),
            usedQuantity: Number(row.usedQuantity || 0),
            remainingQuantity:
              row.remainingQuantity == null
                ? total < 0
                  ? -1
                  : Math.max(0, (Number.isFinite(total) ? total : 0) - received)
                : Number(row.remainingQuantity)
          });
        });
      }
    },
    remainingQuantityText(row) {
      const total = Number(row.totalQuantity);
      if (total < 0) return "不限量";
      const remaining = Number(row.remainingQuantity);
      return `${Number.isFinite(remaining) ? remaining : 0} / ${
        Number.isFinite(total) ? total : 0
      }`;
    },
    search() {
      this.query.page = 1;
      this.load();
    },
    reset() {
      this.query = { title: "", displayStatus: null, page: 1, pageSize: this.query.pageSize };
      this.load();
    },
    changePage(v) {
      this.query.page = v;
      this.load();
    },
    changeSize(v) {
      this.query.pageSize = v;
      this.query.page = 1;
      this.load();
    },
    blankForm() {
      const now = Date.now();
      return {
        id: null,
        title: "",
        type: 1,
        campaignType: 1,
        receiveMode: 1,
        inviteRequiredCount: 1,
        inviteRewardQuantity: 1,
        discountAmount: null,
        scopeType: 1,
        scopeValue: "",
        thresholdType: 1,
        thresholdAmount: null,
        validityType: 1,
        validDays: 7,
        useEndTime: null,
        manualReceive: 1,
        claimTimeType: 1,
        claimRange: [now, now + 86400000],
        quantityType: 1,
        totalQuantity: 100,
        userLimit: 1,
        status: 1
      };
    },
    openForm(row) {
      this.selectedProducts = [];
      this.selectedCategoryIds = [];
      this.form = this.blankForm();
      if (row) {
        this.form = Object.assign(this.form, JSON.parse(JSON.stringify(row)));
        this.form.campaignType = Number(row.campaignType || 1);
        this.form.receiveMode = this.effectiveReceiveMode(row);
        this.form.manualReceive = this.form.receiveMode === 1 ? 1 : 0;
        this.form.inviteRequiredCount = Number(row.inviteRequiredCount || 1);
        this.form.inviteRewardQuantity = Number(row.inviteRewardQuantity || 1);
        this.form.thresholdType = Number(row.thresholdAmount) > 0 ? 1 : 0;
        this.form.validityType = row.validDays > 0 ? 1 : 2;
        this.form.claimTimeType = row.startTime <= 0 && row.endTime >= FAR_FUTURE ? 0 : 1;
        this.form.claimRange = this.form.claimTimeType === 1 ? [row.startTime, row.endTime] : [];
        this.form.quantityType = row.totalQuantity < 0 ? 0 : 1;
        if (row.scopeType === 4)
          this.form.scopeValue = (row.scopeValue || "").split(",").filter(Boolean);
        if (row.scopeType === 3)
          this.selectedCategoryIds = (row.scopeValue || "").split(",").filter(Boolean);
        if (row.scopeType === 2)
          this.selectedProducts = (row.scopeValue || "")
            .split(",")
            .filter(Boolean)
            .map(id => ({ id, name: "商品ID " + id }));
      }
      this.formVisible = true;
    },
    selectProducts(rows) {
      this.selectedProducts = rows;
      this.form.scopeValue = rows.map(v => v.id).join(",");
    },
    submit() {
      this.$refs.form.validate(async ok => {
        if (!ok) return;
        if (this.form.scopeType === 2 && !this.selectedProducts.length)
          return this.$message.error("请选择适用商品");
        if (this.form.scopeType === 3 && !this.selectedCategoryIds.length)
          return this.$message.error("请选择适用品类");
        if (this.form.scopeType !== 1 && this.form.scopeType !== 3 && !this.form.scopeValue.length)
          return this.$message.error("请选择优惠券适用范围");
        if (this.form.validityType === 2 && !this.form.useEndTime)
          return this.$message.error("请选择使用截止时间");
        if (
          this.form.claimTimeType === 1 &&
          (!this.form.claimRange || this.form.claimRange.length !== 2)
        )
          return this.$message.error("请选择活动时间");
        if (
          this.form.campaignType === 2 &&
          (this.form.claimTimeType !== 1 ||
            !this.form.inviteRequiredCount ||
            !this.form.inviteRewardQuantity)
        )
          return this.$message.error("请完整配置邀请活动时间和奖励规则");
        const p = Object.assign({}, this.form);
        if (p.scopeType === 3) p.scopeValue = this.selectedCategoryIds.join(",");
        p.manualReceive = p.receiveMode === 1 ? 1 : 0;
        p.thresholdAmount = p.thresholdType === 1 ? p.thresholdAmount : 0;
        p.validDays = p.validityType === 1 ? p.validDays : 0;
        p.useEndTime = p.validityType === 2 ? p.useEndTime : null;
        p.startTime = p.claimTimeType === 1 ? p.claimRange[0] : 0;
        p.endTime = p.claimTimeType === 1 ? p.claimRange[1] : FAR_FUTURE;
        p.totalQuantity =
          p.receiveMode === 1 ? (p.quantityType === 1 ? p.totalQuantity : -1) : -1;
        if (p.campaignType !== 2) {
          p.inviteRequiredCount = null;
          p.inviteRewardQuantity = null;
        }
        if (Array.isArray(p.scopeValue)) p.scopeValue = p.scopeValue.join(",");
        delete p.claimRange;
        delete p.thresholdType;
        delete p.validityType;
        delete p.claimTimeType;
        delete p.quantityType;
        delete p.remainingQuantity;
        delete p.receivedQuantity;
        delete p.issuedQuantity;
        delete p.usedQuantity;
        delete p.displayStatus;
        this.saving = true;
        try {
          const r = await saveCoupon(p);
          if (r.bizcode === 100) {
            this.$message.success("保存成功");
            this.formVisible = false;
            this.load();
          }
        } finally {
          this.saving = false;
        }
      });
    },
    handleCampaignTypeChange(type) {
      if (type === 2) {
        this.form.receiveMode = 3;
        this.form.manualReceive = 0;
        this.form.claimTimeType = 1;
        if (!this.form.userLimit) this.form.userLimit = 1;
      } else if (type === 1 && this.form.receiveMode === 3) {
        this.form.receiveMode = 1;
        this.form.manualReceive = 1;
      }
    },
    syncManualReceive(mode) {
      this.form.manualReceive = mode === 1 ? 1 : 0;
    },
    handleScopeTypeChange(scopeType) {
      this.form.scopeValue = scopeType === 4 ? [] : "";
      this.selectedProducts = [];
      this.selectedCategoryIds = [];
    },
    async loadCategoryNames() {
      try {
        const r = await getCategoryTree({});
        if (r.bizcode !== 100) return;
        const map = {};
        const walk = (rows, path = []) => {
          (rows || []).forEach(row => {
            const current = path.concat(row.name);
            map[String(row.id)] = current.join(" / ");
            walk(row.children, current);
          });
        };
        walk(r.data || []);
        this.categoryNameMap = map;
      } catch (e) {
        this.categoryNameMap = {};
      }
    },
    scopeText(row) {
      const type = Number(row.scopeType);
      if (type === 1) return "全场通用";
      const ids = (row.scopeValue || "").split(",").filter(Boolean);
      if (type === 2) return ids.length ? `指定 ${ids.length} 个商品` : "指定商品";
      if (type === 4) {
        const names = ids.map(id => {
          const option = this.productTypes.find(item => String(item.key) === String(id));
          return option ? option.value : `专区 ${id}`;
        });
        return names.length ? names.join("、") : "指定专区";
      }
      if (type === 3) {
        const names = ids.map(id => this.categoryNameMap[String(id)] || `分类 ${id}`);
        if (!names.length) return "指定品类";
        return names.length > 3
          ? `${names.slice(0, 3).join("、")} 等 ${names.length} 个品类`
          : names.join("、");
      }
      return "-";
    },
    closeCoupon(row) {
      this.$confirm(
        "确定要关闭该优惠券吗？关闭后不可领取，会员已领取且未使用的优惠券将变为失效。",
        "关闭优惠券",
        { type: "warning" }
      )
        .then(async () => {
          const r = await updateCouponStatus({ id: row.id, status: 2 });
          if (r.bizcode === 100) {
            this.$message.success("已关闭");
            this.load();
          }
        })
        .catch(() => {});
    },
    remove(row) {
      this.$confirm("确定要删除该优惠券吗？", "删除优惠券", { type: "warning" })
        .then(async () => {
          const r = await deleteCoupon({ id: row.id });
          if (r.bizcode === 100) {
            this.$message.success("删除成功");
            this.load();
          }
        })
        .catch(() => {});
    },
    openIssue(row) {
      this.activeCoupon = row;
      this.issue = { targetType: 1, quantity: 1, gradeIds: [] };
      this.selectedMembers = [];
      this.issueVisible = true;
    },
    async doIssue() {
      if (this.issue.targetType === 2 && !this.selectedMembers.length)
        return this.$message.error("请选择发放会员");
      if (this.issue.targetType === 3 && !this.issue.gradeIds.length)
        return this.$message.error("请选择会员等级");
      this.issuing = true;
      try {
        const r = await issueCoupon({
          templateId: this.activeCoupon.id,
          targetType: this.issue.targetType,
          userIds: this.selectedMembers.map(v => v.id).join(","),
          gradeIds: this.issue.gradeIds.join(","),
          quantity: this.issue.quantity
        });
        if (r.bizcode === 100) {
          this.$message.success("发放成功，共发放 " + (r.data || 0) + " 张");
          this.issueVisible = false;
          this.load();
        }
      } finally {
        this.issuing = false;
      }
    },
    openRecords(row) {
      this.activeCoupon = row;
      this.recordQuery = { templateId: row.id, keyword: "", status: null, page: 1, pageSize: 10 };
      this.recordsVisible = true;
      this.loadRecords();
      this.loadRecordStats();
    },
    async loadRecords() {
      this.recordLoading = true;
      try {
        const r = await getCouponRecords(this.recordQuery);
        const d = r.data || {};
        this.records = d.entitys || [];
        this.recordTotal = d.totalCount || 0;
      } finally {
        this.recordLoading = false;
      }
    },
    async loadRecordStats() {
      const all = await getCouponRecords({
        templateId: this.activeCoupon.id,
        page: 1,
        pageSize: 100000
      });
      const rows = (all.data && all.data.entitys) || [];
      this.recordStats = {
        total: rows.length,
        used: rows.filter(v => v.status === 2).length,
        expired: rows.filter(v => v.status === 3).length,
        invalid: rows.filter(v => v.status === 4).length
      };
    },
    recordPage(v) {
      this.recordQuery.page = v;
      this.loadRecords();
    },
    recordSize(v) {
      this.recordQuery.pageSize = v;
      this.recordQuery.page = 1;
      this.loadRecords();
    },
    openIssueRecords(row) {
      this.issueRecordQuery = { templateId: row.id, page: 1, pageSize: 10 };
      this.issueRecordsVisible = true;
      this.loadIssueRecords();
    },
    async loadIssueRecords() {
      this.issueRecordLoading = true;
      try {
        const r = await getCouponIssueRecords(this.issueRecordQuery);
        const d = r.data || {};
        this.issueRecords = d.entitys || [];
        this.issueRecordTotal = d.totalCount || 0;
      } finally {
        this.issueRecordLoading = false;
      }
    },
    issueRecordPage(v) {
      this.issueRecordQuery.page = v;
      this.loadIssueRecords();
    },
    issueRecordSize(v) {
      this.issueRecordQuery.pageSize = v;
      this.issueRecordQuery.page = 1;
      this.loadIssueRecords();
    },
    resolveDisplayStatus(row) {
      const serverStatus = Number(row.displayStatus);
      if ([1, 2, 3, 4].includes(serverStatus)) return serverStatus;
      const now = Date.now();
      if (Number(row.status) !== 1) return 4;
      const start = Number(row.startTime || 0),
        end = Number(row.endTime || 0);
      if (start > now) return 1;
      if (end > 0 && end < now) return 3;
      return 2;
    },
    effectiveReceiveMode(row) {
      return Number(row.receiveMode || (Number(row.manualReceive) === 1 ? 1 : 2));
    },
    campaignText(v) {
      return { 1: "普通券", 2: "邀请券", 3: "新人券" }[Number(v || 1)] || "普通券";
    },
    receiveModeText(v) {
      return { 1: "手动领取", 2: "后台发放", 3: "自动发放" }[Number(v)] || "-";
    },
    money(v) {
      return Number(v || 0).toFixed(2);
    },
    date(v) {
      return v ? moment(v).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
    claimText(r) {
      return r.startTime <= 0 && r.endTime >= FAR_FUTURE
        ? "不限时"
        : this.date(r.startTime) + " 至 " + this.date(r.endTime);
    },
    validityText(r) {
      return r.validDays > 0
        ? "领取后 " + r.validDays + " 天有效"
        : "使用截止至 " + this.date(r.useEndTime);
    },
    statusText(v) {
      const x = this.statuses.find(s => s.value === Number(v));
      return x ? x.label : "-";
    },
    statusType(v) {
      return { 1: "info", 2: "success", 3: "warning", 4: "danger" }[Number(v)] || "info";
    },
    sourceText(v) {
      return { 1: "用户主动领取", 2: "后台发放", 3: "营销活动" }[v] || "历史记录";
    },
    couponStatus(v) {
      return { 1: "待使用", 2: "已使用", 3: "已过期", 4: "已失效" }[v] || "-";
    }
  }
};
</script>
<style scoped lang="scss">
.coupon-page {
  background: #f5f7fa;
  min-height: calc(100vh - 84px);
}
.filter-card,
.table-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 16px;
}
.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 22px;
}
.filters {
  display: flex;
  gap: 12px;
  align-items: center;
}
.filters .el-input {
  width: 240px;
}
.toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}
.count-lines {
  display: flex;
  flex-direction: column;
  line-height: 22px;
}
.danger-link {
  color: #f56c6c;
}
.el-pagination {
  margin-top: 18px;
  text-align: right;
}
.unit {
  margin-left: 10px;
  color: #606266;
}
.help {
  font-size: 12px;
  color: #909399;
  line-height: 20px;
}
.campaign-tip {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 4px;
  background: #f5f7fa;
  color: #606266;
  line-height: 20px;
}
.invite-rule {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.inline-field,
.scope-picker {
  margin-top: 12px;
  display: flex;
  gap: 10px;
  align-items: center;
}
.scope-category-picker {
  margin-top: 12px;
}
.scope-text {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 20px;
}
.record-summary {
  display: flex;
  gap: 70px;
  margin: 0 0 20px 8px;
}
.record-summary div {
  display: flex;
  flex-direction: column;
}
.record-summary b {
  font-size: 28px;
  font-weight: 500;
  color: #303133;
}
.record-summary span {
  margin-top: 5px;
  color: #606266;
}
.filters.compact {
  margin-bottom: 16px;
}
.filters.compact .el-input {
  width: 240px;
}
</style>
